import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import 'rxjs/Rx';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-cadethomepage',
  templateUrl: './cadethomepage.component.html',
  styleUrls: ['./cadethomepage.component.css']
})
export class CadethomepageComponent implements OnInit {
  disableButton1: any;
  disableButton2: any;
  disableButton3: any;
  ApplicationCount: any;
  submitDataResponse: any;
  cadetAllowApplicantApi = environment.baseUrl + "/application_status";
  cadetDemographyApi = environment.baseUrl + "/demographics";
  genderDropdownValue: any;
  hispanicDropdownValue: any;
  raceDropdownValue: any;
  applicantCount = false;
  applicationClosed = false;

  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit() {
    this.checkApplicationClosedStatus()
  }

  goToCadetAppForm() {
    // calling the demography api here.
    this.onSubmitApplicatoin();
    //this.router.navigate(['cadetapplicationform']);
  }

  checkApplicationClosedStatus(){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8','apikey':environment.apikey });
    this.http.get(this.cadetAllowApplicantApi,{headers})
      .subscribe(
        (data:any) => {
          this.ApplicationCount = data;
          if(data.msg){
            this.applicationClosed = true;
          
          }
        },
        error => {
          alert("There was an error processing your request, please try again later.");
        },
        () => {
         
        });
  }

  showCadetForm(){
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8','apikey':environment.apikey });
    this.http.get(this.cadetAllowApplicantApi,{headers})
      .subscribe(
        (data:any) => {
          this.ApplicationCount = data;
         // if(data.ispause_flag==="TRUE"){
          if(data.msg){
            /* We can set here the count of applications as desired by the business team */
             alert(data.msg)
          } else {
            this.router.navigate(['cadetapplicationform']);
          
          }
        },
        error => {
          alert("There was an error processing your request, please try again later.");
        },
        () => {
         
        });
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  onGenderChange(e) {
    this.genderDropdownValue = e.target.value;
  }

  onRaceChange(e) {
    this.raceDropdownValue = e.target.value;
  }

  onHispanicChange(e) {
    this.hispanicDropdownValue = e.target.value;
  
  }

  getCorrectValue(str,key){

    if(typeof(str)==='undefined'||str==='Select'){
      return `${key==='GENDER' ? 'Unknown/' :''}I choose not to disclose` 
    }
    return str;
  }
  onSubmitApplicatoin() {
    let body: string = '{' +
    '"GENDER":"' + this.getCorrectValue(this.genderDropdownValue,'GENDER') + '",' +
    '"RACE":"' + this.getCorrectValue(this.raceDropdownValue,'RACE') + '",' +
    '"HISPANIC":"' + this.getCorrectValue(this.hispanicDropdownValue,'HISPANIC') + '"' +
    '}';

  
    const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8','apikey':environment.apikey });

    this.http.post(this.cadetDemographyApi, body, { headers })
      .subscribe(
        (data) => {
          this.submitDataResponse = data;
          this.showCadetForm();
        },
        error => {
          alert("There was an error processing your request, please try again later.");
        },
        () => {
        
        }
      );
  }
}


// WEBPACK FOOTER //
// ./src/app/cadethomepage/cadethomepage.component.ts